import React, { Component } from 'react';
import { connect } from 'react-redux';
import {
  Field,
  reduxForm,
  stopSubmit,
  getFormValues,
} from 'redux-form';
import {
  Form,
  FormGroup,
  Label,
  Alert,
} from 'reactstrap';

import TextInput from '../../system/fields/TextInput';
import SelectDropdown from '../../system/fields/SelectDropdown';
import FileUpload from '../../system/fields/FileUpload';

import * as validations from '../../system/utils/Validation';

import { getOverview } from '../../store/overview';
import Wysiwyg from '../../system/fields/Wysiwyg';

class EditForm extends Component {
  // constructor() {
  //   super();

  //   this.toggleCruiseLine = this.toggleCruiseLine.bind(this);
  // }
  state = {
    activeTab: 1,
    // cruiseLineToggle: false,
  };

  // toggleCruiseLine() {
  //   this.setState({
  //     cruiseLineToggle: !this.state.cruiseLineToggle,
  //   });
  // }

  toggleTab(tab) {
    if (this.state.activeTab !== tab) {
      this.setState({
        activeTab: tab,
      });
    }
  }

  componentDidMount() {
    this.props.dispatch(getOverview());
  }

  render() {
    const { props } = this;
    const { handleSubmit } = this.props;
    

    return (
      <section className='edit-form'>
        <Form onSubmit={handleSubmit}>
            <section className="form-section">
                <div className="row">
        
                    <FormGroup className="col-12 col-sm-4">
                        <Label>Title</Label>
                        <Field
                             name='title'
                             placeholder='Enter Banner Title'
                             component={TextInput}
                             type='text'
                            //  validate={validations.required}
                        />
                    </FormGroup>

                    <FormGroup className="col-12 col-sm-4">
                        <Label>Banner Link</Label>
                        <Field
                             name='link'
                             placeholder='Enter Banner Link'
                             component={TextInput}
                             type='text'
                            //  validate={validations.required}
                        />
                    </FormGroup>
                   
                </div>

                <div class="row">
                    <FormGroup className="col-12">
                      <Label>Excerpt</Label>
                      <Field
                          name="excerpt"
                          placeholder='Enter Banner Excerpt'
                          component={Wysiwyg}
                          type="text"
                          // validate={validations.required}
                      />
                    </FormGroup>
                </div>
                <div class="row">
                    <FormGroup className="col-12">
                        <Label>Banner Images</Label>
                        <p className='instruction'>
                        Images must be 1920 x 1080 or bigger in the same aspect
                        ratio
                        </p>
                        <Field
                        name='banner_image'
                        component={FileUpload}
                        multiple={false}
                        files={false}
                        images={true}
                        type='text'
                        className='form-control'
                        validate={validations.required}
                        />
                    </FormGroup>
                </div>


                    
            </section>
        
        </Form>

        {this.props.submitFailed && (
          <div className='error-container'>
            <Alert color='danger'>
              <strong>There are errors in your form.</strong>
              <br />
              Please check before submitting again.
            </Alert>
          </div>
        )}
      </section>
    );
  }
}

EditForm = reduxForm({
  form: 'BannerForm',
  onChange: (values, dispatch, props) => {
    if (props.error || props.submitFailed) {
      dispatch(stopSubmit('BannerForm'));
    }
  },
  destroyOnUnmount: false,
})(EditForm);

const mapStateToProps = (state) => {
  return {
    formValues: getFormValues('BannerForm')(state),
    banners: state.overview.banners,
  };
};

export default connect(mapStateToProps)(EditForm);



// WEBPACK FOOTER //
// ./src/containers/Banners/Form.jsx